import React from 'react';
import Row from '../shared/components/Row';
import Card from '../shared/components/Card';
import CardHeader from '../shared/components/card-header/CardHeader';
import { I18nUtils } from '../../i18n/I18nUtils';
import CardBody from '../shared/components/CardBody';
import { connect } from 'react-redux';
import * as attachmentActions from './attachmentActions';
import bindActionCreators from 'redux/es/bindActionCreators';
import AttachmentList from './AttachmentList';
import { ButtonLabel } from '../shared/components/ButtonLabel';

class AttachmentResumeCard extends React.Component {

    render() {
        const {
            files,
            documents,
        } = this.props;

        return (
            <Row clearfix>
                <Card loading={false}>
                    <CardHeader title={I18nUtils.tr('TR_FICHEROS_ADJUNTADOS_A_LOS_DOCUMENTOS').toUpperCase()}/>
                    <CardBody>
                        <AttachmentList
                            files={files}
                            documents={documents}
                        />
                        <Row>
                            <ButtonLabel
                                label={I18nUtils.tr('TR_FINALIZAR')}
                                className={'col-md-4 col-md-offset-8'}
                                onClick={this.handleFinish}
                            />
                        </Row>
                    </CardBody>
                </Card>
            </Row>
        );
    }

    handleFinish = () => {
        const {
            attachmentActions,
            backPathname,
        } = this.props;

        attachmentActions.goBack(backPathname);
    };

}

const mapStateToProps = (state, ownProps) => {
    return {
        files: state.attachment.files,
        documents: state.attachment.documents,
        documentRevisions: state.attachment.documentRevisions,
        backPathname: state.attachment.backPathname,
    };
};

const mapDispatchToProps = dispatch => ( {
    attachmentActions: bindActionCreators(attachmentActions, dispatch),
} );

export default connect(mapStateToProps, mapDispatchToProps)(AttachmentResumeCard);

AttachmentResumeCard.propTypes = {};

AttachmentResumeCard.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/attachment/AttachmentResumeCard.jsx